<template>
  <div>
    <v-dialog v-model="resetPasswordDialog" persistent max-width="500">
      <v-card>
        <v-card-title>{{ $t('account.change_password') }}</v-card-title>
        <v-card-text class="py-5">
          <span>{{ $t('account.new_password') }}</span>
          <v-text-field
            background-color="grey lighten-4"
            flat
            solo
            label="New password"
            v-model="password"
            type="password"
          ></v-text-field>
          <span>{{ $t('account.confirm_password') }}</span>
          <v-text-field
            background-color="grey lighten-4"
            flat
            solo
            label="Confirm password"
            v-model="confirmPassword"
            type="password"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            elevation="0"
            @click="resetPasswordDialog = false"
          >
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            :loading="isLoading"
            @click="changeUserPassword"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="isColor || 'error'" v-model="isError" top centered>
      {{ isErrorText || $t('error') }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "PageName",
  computed: {
    resetPasswordDialog: {
      get() {
        if (this.value) {
          this.resetForm();
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {},
  data() {
    return {
      password: "",
      confirmPassword: "",
      isError: false,
      isErrorText: "",
      isLoading: false,
      isColor: "",
    };
  },
  props: {
    value: Boolean,
  },
  methods: {
    resetForm() {
      this.password = "";
      this.confirmPassword = "";
    },
    async changeUserPassword() {
      const { password, confirmPassword } = this;
      try {
        if (password.length >= 8) {
          if (password == confirmPassword) {
            this.isLoading = true;
            await this.$store.dispatch("user/changeUserPassword", { password });
            this.$store.commit("resetSessionToken");
            this.$router.push("/auth/login?isChanged=true");
            this.isLoading = false;
          } else {
            this.isError = true;
            this.isErrorText = this.$t('account.password_not_match');
          }
        } else {
          this.isError = true;
          this.isErrorText = this.$t('validate.password_must_be_at_least_eight_characters');
        }
      } catch (e) {
        this.isLoading = false;
        this.isError = true;
        this.isErrorText = this.$t('validate.network_error');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
